import React, { useEffect, useRef } from 'react';
import './AboutSlides.css';

// 1. IMPORTING THE LOGO
import SmartlightLogoWhite from '../Images/SmartlightLogoWhite.png';
import Light1 from '../Images/Smartlight_AD_Feature.jpg';

// 2. RESTRUCTURED SLIDE DATA
const slides = [
  {
    image: Light1,
    title: 'Commitment That Continues After Delivery',
    // We split the subtitle into parts to inject the logo
    hasLogo: true,
    textParts: {
      before: 'At ',
      after: `, we pride ourselves on unmatched after-sales service.
Any product with manufacturing defects or normal-use issues is repaired or replaced immediately—no delays, no hassle.

With our in-house technical team and manufacturing unit, we ensure quick, dependable support—no reliance on third parties.`
    }
  }
];

export default function AboutSlides() {
  const indicatorRef = useRef();

  useEffect(() => {
    let scrolled = false;
    function hideIndicator() {
      if (!scrolled && indicatorRef.current) {
        indicatorRef.current.style.opacity = '0';
        scrolled = true;
      }
    }
    window.addEventListener('scroll', hideIndicator);
    document.documentElement.style.scrollBehavior = 'smooth';

    return () => {
      window.removeEventListener('scroll', hideIndicator);
    };
  }, []);

  return (
    <div>
      <div className="scroll-indicator" ref={indicatorRef}>↓ Scroll Down ↓</div>
      {slides.map((slide, i) => (
        <div className="slide" key={i}>
          {slide.image ? (
            <div className="slide-bg" style={{ backgroundImage: `url('${slide.image}')` }} />
          ) : (
            <div className="slide-bg" style={{ background: slide.bg || '#1D354D' }} />
          )}
          <div className="slide-overlay" />
          <div className="slide-content">
            <h1 className="slide-title">{slide.title}</h1>
            
            {/* 3. CONDITIONAL RENDERING FOR THE SUBTITLE */}
            {slide.hasLogo ? (
              <p className="slide-subtitle">
                {slide.textParts.before}
                <img src={SmartlightLogoWhite} alt="Smartlight Logo" className="inline-logo" />
                {slide.textParts.after}
              </p>
            ) : (
              <p className="slide-subtitle">{slide.subtitle}</p>
            )}
            
          </div>
        </div>
      ))}
    </div>
  );
}